import { useTranslation } from 'react-i18next';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

import PropTypes from 'prop-types';

export default function MainParticipantFields({
  mainParticipants,
  formatIndex,
  formatFullname,
  formatGender,
  formatOrganizationName,
}) {
  // #region Data
  const { t } = useTranslation();
  // #endregion Data

  return (
    mainParticipants?.length > 0 && (
      <>
        <h4>{t('projectProposal.general.researchHumanResources.mainParticipantFields.label')}</h4>
        <p>{t('projectProposal.general.researchHumanResources.ownerFields.note')}</p>
        <div className="grid">
          <div className="col-12">
            <DataTable
              value={mainParticipants}
              className="p-datatable-gridlines"
              showGridlines
              dataKey="contact.id"
              responsiveLayout="scroll"
            >
              <Column
                header={t('formLayout.numericalOrder')}
                body={formatIndex}
                className="text-center"
                style={{ textAlign: 'center', width: '5%' }}
              />
              <Column
                header={`${t(
                  'projectProposal.general.researchHumanResources.fields.academicRank'
                )}, ${t(
                  'projectProposal.general.researchHumanResources.fields.academicDegree'
                )}, ${t('projectProposal.general.researchHumanResources.fields.name')}`}
                body={formatFullname}
                style={{ minWidth: 100, width: '22%' }}
              />
              <Column
                header={t('projectProposal.general.researchHumanResources.fields.gender')}
                body={formatGender}
                style={{ minWidth: 100, width: '5%' }}
              />
              <Column
                header={t('projectProposal.general.researchHumanResources.fields.organization')}
                body={formatOrganizationName}
                style={{ minWidth: 200, width: '28%' }}
              />
            </DataTable>
          </div>
        </div>
      </>
    )
  );
}

MainParticipantFields.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  mainParticipants: PropTypes.array.isRequired,
  formatIndex: PropTypes.func.isRequired,
  formatFullname: PropTypes.func.isRequired,
  formatGender: PropTypes.func.isRequired,
  formatOrganizationName: PropTypes.func.isRequired,
};
